import { RouteComponentProps } from 'react-router-dom';

export enum CheckoutTabName {
    Checkout = 'checkout',
    Draft = 'draft',
}

export interface DateOptionsInterface {
    isBorderBottom?: boolean;
    value: number | string;
    label: string;
}

export enum TabNameEnum {
    Draft = 'draft',
    Checkout = '',
}
interface TabParams {
    tabName: string;
}

export type CheckoutsListProps = RouteComponentProps<TabParams>;

export type FilterOptions = { label: string; value: string, count: number };

export interface MobileFilterTabsProps {
    label: string;
    type: 'checkbox' | 'radio' | 'date';
    defaultValue?: string;
    defaultCheckboxValue?: string[];
    options: {
        value: string | number;
        label: string;
        count?: string | number;
    }[];
    startDate?: string;
    endDate?: string;
}

export interface CheckoutDeleteModalProps {
    checkedCheckouts: string[];
    deleteConfirmationText: string;
    setDeleteConfirmationText: (deleteConfirmationText:string) => void;
    changeDeleteConfirmationText: (deleteConfirmationText: string) => void;
}

export const CHECKOUT_DELETE_CONFIRMATION_TEXT = 'delete';
